import {
  getStatusesSuccess,
  getStatusesInvoked,
  GET_STATUSES,
} from "src/redux/actions/travelerTracker";
import { put, takeLatest, select } from "redux-saga/effects";
import { computeStatuses } from "src/services/itineraryDetails";
import { ItineraryI } from "src/redux/reducers/itineraryDetails";
import { ApplicationStateI } from "src/redux/reducers/application";

function* getStatuses({ id }: { id: string; type: string }) {
  yield put(getStatusesInvoked(id));
  const state = yield select();
  const itineraries: ItineraryI[] = state.itineraryDetails.ids[id].data;
  const application: ApplicationStateI = state.application;
  const statuses = computeStatuses(itineraries, application.flightStatusEnum);
  yield put(getStatusesSuccess(statuses, id));
}

function* travelerTrackerSaga() {
  yield takeLatest(GET_STATUSES, getStatuses);
}

export default travelerTrackerSaga;
